import { getDataFromServer } from "../util";
import { VALIDATE_CONTRACT_AGENT } from "./types";

export const validContractAgent = value => async dispatch => {
  try {
    dispatch({ type: VALIDATE_CONTRACT_AGENT, payload: value });
  } catch (e) {}
};

export const getPermissions = async () => getDataFromServer("GET", "/contractAgent/permissions", null, true);
export const getClasses = async () => getDataFromServer("GET", "/contractAgent/classes", null, true);
